import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Error from '@material-ui/icons/ErrorOutline';

const jss = (theme: Theme) => createStyles({
    title: {
        textAlign: 'center',
    },
    icon: {
        width: '100%',
    },
    actions: {
        margin: '0px',
        padding: '12px',
    },
});

interface Props {
    open: boolean;
    message?: string;
    onClose: () => void;
    classes: {
        title: string;
        icon: string;
        actions: string;
    }
}

class FailDialog extends React.Component<Props, {}> {
    render() {
        const { classes } = this.props;

        if (!this.props.open) {
            return null;
        }

        return (
                <Dialog open={true} disableBackdropClick>
                    <DialogTitle className={classes.title}>Submission Error!</DialogTitle>
                    <DialogContent>
                        <DialogContentText paragraph align="center">
                            {this.props.message || 'Unexpected error occured'}
                        </DialogContentText>
                        <Error fontSize="large" color="error" className={classes.icon} />
                    </DialogContent>
                    <DialogActions className={classes.actions}>
                        <Button
                            onClick={this.props.onClose}
                            variant="contained"
                            fullWidth
                            autoFocus
                        >
                            OKAY
                        </Button>
                    </DialogActions>
                </Dialog>
        )
    }
}

export default withStyles(jss)(FailDialog);



// WEBPACK FOOTER //
// ./src/components/Common/FailDialog.tsx